import React from 'react';

import { useIntl } from 'react-intl';

import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { queryClient } from 'src/lib/react-query';
import { toast } from 'src/hooks/useToast';
import { ServicePlanCategory } from 'src/features/servicePlanCategory/utils/types';
import ServicePlanCategoryFormModal from './ServicePlanCategoryFormModal';
import { useUpdateServicePlanCategory } from 'src/features/servicePlanCategory/api/useUpdateServicePlanCategory';
import {
    LIST_SERVICE_PLAN_CATEGORIES_RESOURCE
} from 'src/features/servicePlanCategory/api/useListServicePlanCategories';
import { servicePlanCategoriesMessages } from 'src/features/servicePlanCategory/utils/messages';

interface UpdateServicePlanCategoryFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanCategory: ServicePlanCategory;
    children?: React.ReactNode;
}

function UpdateServicePlanCategoryFormModal<TData>({
                                                   className,
                                                   semantics,
                                                   children,
                                                   selectedServicePlanCategory,
                                               }: UpdateServicePlanCategoryFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useUpdateServicePlanCategory({
        onSuccess: ({ name }) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_CATEGORIES_RESOURCE] });
            toast({
                title: formatMessage(servicePlanCategoriesMessages.updateServicePlanCategorySuccess),
                description: formatMessage(servicePlanCategoriesMessages.updateServicePlanCategorySuccessDescription, {
                    entity: name,
                }),
            });
        },
    });

    return (
        <ServicePlanCategoryFormModal
            selectedServicePlanCategory={selectedServicePlanCategory}
            className={className}
            mutate={(values, onSuccess, onError) =>
                mutate({ ...values, id: selectedServicePlanCategory.id }, { onSuccess, onError })
            }
            title={formatMessage(generalMessages.editEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.EDIT}
            isPending={isPending}
            subtitle={formatMessage(servicePlanCategoriesMessages.editServicePlanCategorySubtitle, {
                entity: selectedServicePlanCategory.name,
            })}
        >
            {children}
        </ServicePlanCategoryFormModal>
    );
}

export default UpdateServicePlanCategoryFormModal;
